import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { get, isEmpty } from "lodash";

export default function PoCode({ inventory }) {
  // If there is no inventory object at all, don’t render anything:
  if (!inventory) return null;

  const {
    purchase_order_code: purchaseOrderCode,
    most_recent_purchase_order,
    purchase_order_id: purchaseOrderId,
    lot_id: lotId
  } = inventory;

  if (!isEmpty(most_recent_purchase_order) && purchaseOrderCode) {
    return (
      <Link to={`/purchase-orders/${most_recent_purchase_order.uuid}`}>
        {purchaseOrderCode}
      </Link>
    );
  }

  if (lotId) {
    return (
      <Link to={`/lots/${get(inventory, "lot_details.uuid")}`}>
        {get(inventory, "lot_details.code")}
      </Link>
    );
  }

  return purchaseOrderId ? (
    <Link to={`/purchase-orders/${purchaseOrderId}`}>{purchaseOrderCode}</Link>
  ) : (
    <span>{purchaseOrderCode}</span>
  );
}

PoCode.propTypes = {
  inventory: PropTypes.shape({
    purchase_order_code: PropTypes.string,
    purchase_order_id: PropTypes.number,
    most_recent_purchase_order: PropTypes.object,
    lot_id: PropTypes.number
  })
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/PoCode/PoCode.jsx